
import React from 'react';
import { Outlet } from 'react-router';

const WithoutNav = () => <Outlet />

export default WithoutNav